import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { InputComponent } from "../../../components/InputComponent";
import { TablaDinamica } from "../../../components/TablaDinamica";
import * as generic from "../../../components/Generico";
import { useLazyParams } from "../../../hooks/useLazyParams";
import { Actividad } from "../../../models/ficha/Actividad";
import { ActividadService } from "../../../service/ficha/ActividadService";
import { InputActividadEconomica } from "../../../components/ui/Formularios/InputActividadEconomica";

export const ActividadBienServicio = ({ toast, id, tipo, permss, soloLectura }) => {

    const omodel = new Actividad();
    const defaultValues = generic.funDefault(omodel.model, null);

    const [dialogVisible, setDialogVisible] = useState(false);
    const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
    const menuRef = useRef(null);

    const actividadSrv = new ActividadService();
    const tablaActividad = useLazyParams({ modelo: omodel.model });

    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { inArea } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        if (id) loadLazyData();
        // eslint-disable-next-line
    }, [tablaActividad.lazyParams, id]);

    const loadLazyData = () => {
        tablaActividad.setLoading(true);
        const _params = { ...tablaActividad.lazyParams, idp: id, tipo: tipo };
        actividadSrv.lista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaActividad.setTotalRecords(res.data.total);
            tablaActividad.setData(res.data.registros);
        }).finally(() => tablaActividad.setLoading(false));
    };

    const openNew = () => {
        reset(defaultValues);
        setDialogVisible(true);
    };

    const hideDialog = () => setDialogVisible(false);

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;

        const request = getValues('id') == null
            ? actividadSrv.nuevo(data)
            : actividadSrv.editar(data);

        request.then(res => {
            setDialogVisible(false);
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => generic.funcErrorHibrida(error, toast, setError));
    };

    const editRegistro = (idReg) => {
        actividadSrv.consultar(idReg).then(res => {
            const _data = res.data.actividad;
            reset(generic.renewValues(_data, omodel.model));
            setDialogVisible(true);
        });
    };

    const confirmDelete = (idReg) => {
        confirmDialog({
            message: '¿Está seguro de eliminar este registro?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                actividadSrv.eliminar(idReg).then(res => {
                    loadLazyData();
                    generic.funcSuccess(res, toast);
                }).catch(error => generic.funcDeleteError(error, toast));
            }
        });
    };

    const itemsMenu = () => {
        if (soloLectura) {
            return [{
                label: 'Opciones',
                items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editRegistro(registroSeleccionado?.id) }]
            }];
        }
        return [{
            label: 'Opciones',
            items: [
                { label: 'Editar', icon: 'pi pi-pencil', command: () => editRegistro(registroSeleccionado?.id) },
                { label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete(registroSeleccionado?.id) }
            ]
        }];
    };

    const accionesTemplate = (rowData) => (
        <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu_actividad" aria-haspopup onClick={(e) => { setRegistroSeleccionado(rowData); menuRef.current.toggle(e); }} />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Actividades Económicas y Bienes o Servicios
            </span>
        </div>
    );

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error de validación', detail: 'Por favor, verifique los campos requeridos.', life: 5000 });
    }

    return (
        <div className="componente-actividad-bien-servicio">
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_actividad" />
            <TablaDinamica modelo={omodel.model} estadoTabla={tablaActividad} datos={tablaActividad.data} totalRegistros={tablaActividad.totalRecords} dataKey="id" acciones={ColumnaAcciones} header={cabeceraTabla()} />

            <Dialog visible={dialogVisible} header={getValues('id') == null ? "Nueva Actividad Económica / Bien o Servicio" : "Editar Actividad Económica / Bien o Servicio"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={hideDialog} style={{ width: '600px' }}>
                <form onSubmit={(e) => {e.stopPropagation();handleSubmit(onSubmit, onError)(e)}}>
                    <div className="formgrid grid px-2">

                        <div className="col-12 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-briefcase text-primary"></i>
                                    ACTIVIDAD ECONÓMICA Y BIEN O SERVICIO
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>

                        <InputActividadEconomica name="actividad" control={control} modelDef={omodel.model['actividad']} disabled={soloLectura} col={12} />
                        {inArea('bien_servicio', 3, 350, 12)}

                        <div className="col-12 mt-4 pt-3 flex justify-content-end border-top-1 border-300">
                            {soloLectura ? (
                                <div className="field col-auto p-0 m-0">
                                    <Button label="Cerrar" style={{ width: '120px' }} icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                                </div>
                            ) : (
                                generic.buttonsForms(hideDialog)
                            )}
                        </div>
                    </div>
                </form>
            </Dialog>
        </div>
    );
};
